import {
  ApiOutlined,
  BuildOutlined,
  FileTextOutlined,
  HomeOutlined,
  CommentOutlined,
  KeyOutlined,
  RobotOutlined,
  SearchOutlined,
  ShareAltOutlined,
  ShopOutlined,
  ShoppingCartOutlined,
  ThunderboltOutlined,
  UserOutlined
} from '@ant-design/icons';
import { NavItemType } from 'types/menu';

const menu: NavItemType[] = [
  { id: 'dashboard', title: 'Dashboard', icon: HomeOutlined, url: '/dashboard' },
  { id: 'reports', title: 'Reports', icon: FileTextOutlined, url: '/reports' },
  { id: 'drilldown', title: 'Client Drill-down', icon: SearchOutlined, url: '/drilldown' },
  { id: 'salespro', title: 'SalesPro Analytics', icon: ShoppingCartOutlined, url: '/salespro' },
  { id: 'rates', title: 'Rate Card', icon: BuildOutlined, url: '/rates' },
  { id: 'agent-llm-config', title: 'AI Model Config', icon: RobotOutlined, url: '/agent-llm-config' },
  { id: 'provider-connections', title: 'Provider Connections', icon: ApiOutlined, url: '/provider-connections' },
  { id: 'companies', title: 'Companies', icon: ShopOutlined, url: '/companies' },
  { id: 'users', title: 'Users', icon: UserOutlined, url: '/users' },
  { id: 'assistant', title: 'Assistant', icon: CommentOutlined, url: '/assistant' },
  { id: 'api-keys', title: 'API Keys', icon: KeyOutlined, url: '/api-keys' },
  { id: 'partners', title: 'Partners', icon: ShareAltOutlined, url: '/partners' },
  { id: 'promotion', title: 'Promotion', icon: ThunderboltOutlined, url: '/promotion', disabled: true }
];

export default menu;
